import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AssetBreadcrumb } from '../../../../../../../../../../../features/asset/asset-breadcrumb';
import { AssetLogoBreadcrumb } from '../../../../../../../../../../../features/asset/logo/asset-logo-breadcrumb';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset',
)({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `stock-record-takeoff-asset-${params.assetId}`,
        label: <AssetBreadcrumb assetId={params.assetId} />,
        prefix: <AssetLogoBreadcrumb assetId={params.assetId} />,
        to: '/clearing/operations/stock-record',
      }),
    }) satisfies AggregateBreadcrumb,
});
